/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function CaretDownTiny(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'CaretDownTiny',
      'aria-hidden': true,
      focusable: false,
      width:  8 * scale,
      height: 5 * scale,
      viewBox: '0 0 8 5',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M3.47 4.53a.75.75 0 0 0 1.06 0l2.5-2.5A.75.75 0 0 0 5.97.97L4 2.94 2.03.97A.75.75 0 0 0 .97 2.03z","fill":"currentColor","fillRule":"evenodd"}))
}
